import { addStyles } from 'ethcss'
import { IStyles } from '../../theme'

const WikiInfo: IStyles = {
    wikiModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 10002,
    },
    close: {
        position: 'absolute',
        right: 20,
        top: 20,
    },
    iframeWrapper: {
        height: '100%',
        padding: 50,
    },
    iframe: {
        width: '100%',
        height: '100%',
        borderRadius: 10,
    },
}

addStyles(WikiInfo)
export default WikiInfo
